<div class="flex justify-center mt-2 mb-6"
  *ngIf="meeting">
  <div class="flex-col">
    <div class="w-343 tablet:w-768 laptop:w-912 tablet:px-6">
      <div class="bg-light rounded border-l-6 border-neutral-300 shadow-mdlight mobile:p-6 tablet:p-8 w-full">
        <div class="tablet:flex tablet:items-center tablet:justify-between">
          <p class="text-4 tablet:text-5 font-medium text-dark leading-24 mobile:mb-6 tablet:mb-0">{{dashboardInfo?.jobTitle}}</p>
          <button
            class="mobile:w-full tablet:w-auto hover:bg-primary-400 active:bg-primary-700 text-center whitespace-nowrap inline-block py-4 px-6 bg-primary-500 border border-primary-500 text-[14px] text-light rounded-base leading-18"
            (click)="viewDetails()">
            <ng-container *ngIf="meeting.isUpcoming else inPast">
              Confirm Interview
            </ng-container>
            <ng-template #inPast>
              View Details
            </ng-template>
          </button>
        </div>
        <hr class="my-7 text-neutral-100" />
        <!-- Interview Stage -->
        <div class="flex gap-2 mb-4">
            <img class="h-20" src="https://postingpanda.blob.core.windows.net/clientpublicassets/global/content/img/svg/briefcase.svg" alt="Interview Stage">
            <span class="text-4 text-dark leading-24">{{meeting.meetingTitle}}</span>
        </div>
        <!-- Date  -->
        <div class="mb-4">
          <interview-date-widget
            [meeting]="meeting"
          ></interview-date-widget>
        </div>
        <!-- Time -->
        <div class="mb-4">
          <interview-time-widget
            [meeting]="meeting"
          ></interview-time-widget>
        </div>
        <!-- Location  -->
        <interview-location-widget
        [meeting]="meeting"
        [dashboardInfo]="dashboardInfo"
      ></interview-location-widget>
      </div>
    </div>
  </div>
</div>
